import { render, staticRenderFns } from "./AmlReports.vue?vue&type=template&id=4be9db94&scoped=true&lang=pug"
import script from "./AmlReports.vue?vue&type=script&lang=js"
export * from "./AmlReports.vue?vue&type=script&lang=js"
import style0 from "./AmlReports.vue?vue&type=style&index=0&id=4be9db94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be9db94",
  null
  
)

export default component.exports